export default __webpack_public_path__ + "static/media/9.65316a43.webp";